import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User, initialUser } from "../../types/model";

interface UserState {
	user: User;
	isLoggedIn: boolean;
	isMobile: boolean;
	isGmail: boolean;
	showLoginModal: boolean;
	navbarExpanded: boolean;
}

const initialState: UserState = {
	user: initialUser,
	isLoggedIn: false,
	isMobile: false,
	isGmail: false,
	showLoginModal: false,
	navbarExpanded: false,
};

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		login: (state, action: PayloadAction<User>) => {
			state.user = action.payload;
			state.isLoggedIn = true;
		},
		logout: (state) => {
			state.user = initialUser;
			state.isLoggedIn = false;
			state.isGmail = false;
		},
		setIsMobile: (state, action: PayloadAction<boolean>) => {
			state.isMobile = action.payload;
		},
		setShowLoginModal: (state, action: PayloadAction<boolean>) => {
			state.showLoginModal = action.payload;
		},
		setIsGmail: (state, action: PayloadAction<boolean>) => {
			state.isGmail = action.payload;
		},
		setUser: (state, action: PayloadAction<User>) => {
			state.user = action.payload;
		},
		setNavbarExpanded: (state, action: PayloadAction<boolean>) => {
			state.navbarExpanded = action.payload;
		},
		toggleNavbar: (state) => {
			state.navbarExpanded = !state.navbarExpanded;
		}
	},
});

export const {
	login,
	logout,
	setIsMobile,
	setShowLoginModal,
	setIsGmail,
	setUser,
	setNavbarExpanded,
	toggleNavbar,
} = userSlice.actions;
export default userSlice.reducer;
